export default __webpack_public_path__ + "static/media/OG.1a775116.svg";